<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/p2k5Qn/tc-custom/9781620970690.jpg?1734377034406" alt="This image is the cover for the book Math Myth"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Math Myth
      </h1>
      <p class="bookDescription body article font2">
        <b>A <i>New York Times</i>–bestselling author looks at mathematics education in America—when it’s worthwhile, and when it’s not.</b><br/>  <br/> Why do we inflict a full menu of mathematics—algebra, geometry, trigonometry, even calculus—on all young Americans, regardless of their interests or aptitudes? While Andrew Hacker has been a professor of mathematics himself, and extols the glories of the subject, he also questions some widely held assumptions in this thought-provoking and practical-minded book.<br/>  <br/> Does advanced math really broaden our minds? Is mastery of azimuths and asymptotes needed for success in most jobs? Should the entire Common Core syllabus be required of every student? Hacker worries that our nation’s current frenzied emphasis on STEM is diverting attention from other pursuits and even subverting the spirit of the country. Here, he shows how mandating math for everyone prevents other talents from being developed and acts as an irrational barrier to graduation and careers. He proposes alternatives, including teaching facility with figures, quantitative reasoning, and understanding statistics.<br/>  <br/> Expanding upon the author’s viral <i>New York Times</i> op-ed, <i>The Math Myth</i> is sure to spark a heated and needed national conversation—not just about mathematics but about the kind of people and society we want to be.<br/>  <br/> “Hacker’s accessible arguments offer plenty to think about and should serve as a clarion call to students, parents, and educators who decry the one-size-fits-all approach to schooling.” —<i>Publishers Weekly</i>, starred review
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew Hacker
      </h2>
      
      <p class="authorDescription body article">Andrew Hacker is the author of ten books, including The Math Myth: And Other STEM Delusions (The New Press) and the New York Times bestseller Two Nations. He teaches at Queens College and lives in New York City.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The New Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?442d9d96